import EventEmitter from 'eventemitter3';
import { parseUrl } from '../utils/common';
import { pickCover } from '../utils/artwork';

class Base extends EventEmitter {
  constructor(options, gameData) {
    super();
    this.options = options;
    this.gameData = gameData;
  }

  _getThumbnail(options, gameData) {
    // Previously hunted for `width === 512 && height === 512` and fed the result straight to
    // parseUrl, which throws on undefined when a game has no artwork at all (#87).
    const uri = pickCover(gameData.covers);
    return uri ? parseUrl(options.imgHost, uri) : '';
  }
  _registerEvents() {
    const playButton = document.getElementById(`${this.options.prefix}splash-button`);
    if (playButton)
      playButton.addEventListener('click', (event) => {
        this.emit('playClick', event);
      });

    const container = document.getElementById(`${this.options.prefix}splash`);
    if (container)
      container.addEventListener('click', (event) => {
        this.emit('containerClick', event);
      });
  }

  hide() {
    const container = this._container;
    const extContainer = this._extContainer;

    if (container && container.parentNode) container.parentNode.removeChild(container);
    if (extContainer) extContainer.style.display = 'none';
  }

  _insertCss(css) {
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    const existingStyle = document.head.querySelector('style[data-g8-splash-style]');
    if (existingStyle) existingStyle.remove();

    style.type = 'text/css';
    style.setAttribute('data-g8-splash-style', true);

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
  }
  _getExtContainer() {
    if (!this.options.flashSettings.splashContainerId) return;
    return document.getElementById(this.options.flashSettings.splashContainerId);
  }
  getRoot() {
    return this._root;
  }
}

export default Base;
